import { render, staticRenderFns } from "./ProductListView.vue?vue&type=template&id=700dc93f&scoped=true"
import script from "./ProductListView.vue?vue&type=script&lang=js"
export * from "./ProductListView.vue?vue&type=script&lang=js"
import style0 from "./ProductListView.vue?vue&type=style&index=0&id=700dc93f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700dc93f",
  null
  
)

export default component.exports